import React from "react";
import styles from "./index.module.scss";
import { Modal } from "antd";

function BookingProgressConformModal({ isModalOpen, onOk, onCancel }) {
  return (
    <div>
      <Modal
        className={styles.booking_progress_conform_modal}
        title={false}
        open={isModalOpen}
        footer={null}
        closeIcon={<></>}
      >
        <p>
        The data you have entered will be lost. Do you still want to exit this page?
        </p>

        <div className={styles.button_container}>
          <button className={styles.cancel_btn} onClick={onCancel}>No</button>
          <button className={styles.ok_btn}  onClick={onOk}>Yes</button>
        </div>
      </Modal>
    </div>
  );
}

export default BookingProgressConformModal;
